const resize = {
  resize: async (params) => {
    /* To use await in the app wrap this all in a promise */
    const { image, maxWidth, imageQuality } = params
    return readAsDataURL(image, maxWidth, imageQuality)
  }
}
const readAsDataURL = (file, maxWidth, imageQuality) => {
  return new Promise((resolve, reject) => {
    // Create a new file reader to read the file that is being uploaded
    const reader = new window.FileReader()
    // Reject on any errors
    reader.onerror = reject
    // This fires once the reader has finished loading the file
    reader.onload = function (event) {
      // Create an image holder
      const img = new window.Image()
      // Set its src to be the file that is created after the reader has finished
      img.src = event.target.result
      // This fires when the image has finished being created
      img.onload = () => {
        // This holds the image details
        const elem = document.createElement('canvas')
        // Limit the image to 900px but use whatever the image width is if it is smaller than 900
        const width = img.width > maxWidth ? maxWidth : img.width
        // Determine the scale to maintain aspect ratios
        const scaleFactor = width / img.width
        // set the height.
        const height = img.width > width ? img.height * scaleFactor : img.height
        // Set the width and height of the canvas
        elem.width = width
        elem.height = height
        // Prevent the context
        const ctx = elem.getContext('2d')
        // Draw the image and convert to a blob.
        ctx.drawImage(img, 0, 0, width, height)
        ctx.canvas.toBlob((blob) => {
          // Resolve the promise with the freshly created images
          resolve(new window.File([blob], file.name, {
            type: 'image/jpeg',
            lastModified: Date.now()
          }))
        }, 'image/jpeg', imageQuality) // This last param sets the quality. From 0-1 are valid values.
      }
    }
    // Load the file into the reader here.
    reader.readAsDataURL(file)
  })
}
export {
  resize
}
